/**
 * QFR Products — open side cart after Add to Cart (same as cart icon).
 */
import { StandardEvents } from '@shopify/events';

function openCartDrawer() {
  if (typeof window.Shopify?.actions?.openCart === 'function') {
    window.Shopify.actions.openCart();
    return;
  }

  const drawer = document.querySelector('theme-drawer#cart-drawer');
  if (drawer && typeof drawer.open === 'function') {
    drawer.open();
    return;
  }

  const trigger = document.querySelector('[aria-controls="cart-drawer"]');
  if (trigger instanceof HTMLElement) trigger.click();
}

function onCartLinesUpdate(event) {
  if (event.action !== 'add') return;

  const source = event.target;
  if (!(source instanceof Element) || !source.closest('.qfr-products')) return;

  const settle = () => {
    requestAnimationFrame(() => openCartDrawer());
  };

  if (event.promise && typeof event.promise.then === 'function') {
    event.promise
      .then((result) => {
        if (result?.detail?.didError) return;
        settle();
      })
      .catch(() => {});
  } else {
    settle();
  }
}

document.addEventListener(StandardEvents.cartLinesUpdate, onCartLinesUpdate);
